const hy = {
  description:
    'Մենք օգնում ենք աշխարհի լավագույն թիմերին հասնել նոր բարձունքների',
};
export default hy;
